module.exports = __webpack_public_path__ + "410e5e9b627f01deb4c2211fe6ec3ac1.png";